import { Component, OnInit } from '@angular/core';
import { PbSnapImageService, EventProjectService, CommonService } from 'src/app/shared';
import { environment } from '../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
declare var jquery: any;
declare var $: any;
declare var Swal: any;
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as QRCode from 'qrcode';
import * as JSZip from 'jszip';

@Component({
  selector: 'app-list-photos',
  templateUrl: './list-photos.component.html',
  styleUrls: ['./list-photos.component.css']
})
export class ListPhotosComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    private pbSnapImageService: PbSnapImageService,
    private eventProjectService: EventProjectService,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    // ตรวจว่ามาจากหน้า event-project (คลิกดูรายการที่ใช้รหัส) หรือมาจากเมนู/ช่องทางเดิม
    this.route.queryParams.subscribe(params => {
      this.printCodeId = params['print_code_id'] || null;
      this.printCode = params['code'] || null;
      if (this.printCodeId) {
        // โหมด "รหัสที่ใช้"
        this.usageMode = true;
        this.pageTitle = this.printCode ? ('รหัสที่ใช้: ' + this.printCode) : 'รหัสที่ใช้';
        this.currentPage = 1;
        this.getUsages();
      } else {
        // ช่องทางเดิม / จากเมนู
        this.usageMode = false;
        this.pageTitle = 'รายการรูปถ่าย';
        this.loadEventProjects();
        this.getAll();
      }
    });
  }

  photoList: any[] = [];
  eventProjects: any[] = [];
  selectedEventProjectId: number = null;
  selectedIds: Set<number> = new Set();
  isAllSelected: boolean = false;

  // โหมดแสดงรายการที่ใช้รหัสพิมพ์ (มาจากหน้า event-project)
  usageMode: boolean = false;
  printCodeId: string = null;
  printCode: string = null;
  pageTitle: string = 'รายการรูปถ่าย';

  // pagination
  currentPage: number = 1;
  perPage: number = 10;
  totalItems: number = 0;
  lastPage: number = 1;

  get pages(): number[] {
    const range: number[] = [];
    const delta = 2;
    const start = Math.max(1, this.currentPage - delta);
    const end = Math.min(this.lastPage, this.currentPage + delta);
    for (let i = start; i <= end; i++) { range.push(i); }
    return range;
  }

  loadEventProjects() {
    this.eventProjectService.getAll().subscribe(data => {
      this.eventProjects = data;
    });
  }

  // ─── โหลดรายการ ───────────────────────────────────────────────────
  getAll(resetPage: boolean = false) {
    if (resetPage) { this.currentPage = 1; }
    this.spinner.show();
    this.photoList = [];
    this.selectedIds.clear();
    this.isAllSelected = false;

    this.pbSnapImageService.getAll(this.selectedEventProjectId, this.currentPage, this.perPage).subscribe(res => {
      this.totalItems = res.total;
      this.lastPage = res.last_page;
      this.photoList = res.data;
      this.photoList.forEach(item => {
        item['url'] = environment.api_domain + '/api/v1/files-view/' + item.file_manager_id;
        if (item.video_file_manager_id) {
          item['videoUrl'] = environment.api_domain + '/api/v1/files-view/' + item.video_file_manager_id;
        }
        QRCode.toDataURL(item['url'], { errorCorrectionLevel: 'M' })
          .then(url => { item['qrCodeUrl'] = url; })
          .catch(err => { console.error(err); });
      });
      this.spinner.hide();
    }, err => {
      this.spinner.hide();
      console.log(err);
    });
  }

  // ─── โหลดรายการที่ใช้รหัสพิมพ์ (โหมด "รหัสที่ใช้") ──────────────────────
  getUsages() {
    if (!this.printCodeId) { return; }
    this.spinner.show();
    this.photoList = [];
    this.selectedIds.clear();
    this.isAllSelected = false;

    this.eventProjectService.getPrintCodeUsages(this.printCodeId, this.currentPage, this.perPage).subscribe(res => {
      this.totalItems = res.total;
      this.lastPage = res.last_page;
      this.photoList = res.data;
      this.photoList.forEach(item => {
        if (item.file_manager_id) {
          item['url'] = environment.api_domain + '/api/v1/files-view/' + item.file_manager_id;
          if (item.video_file_manager_id) {
            item['videoUrl'] = environment.api_domain + '/api/v1/files-view/' + item.video_file_manager_id;
          }
          QRCode.toDataURL(item['url'], { errorCorrectionLevel: 'M' })
            .then(url => { item['qrCodeUrl'] = url; })
            .catch(err => { console.error(err); });
        }
      });
      this.spinner.hide();
    }, err => {
      this.spinner.hide();
      console.log(err);
    });
  }

  goToPage(page: number) {
    if (page < 1 || page > this.lastPage) { return; }
    this.currentPage = page;
    if (this.usageMode) {
      this.getUsages();
    } else {
      this.getAll();
    }
  }

  // ─── Checkbox: เลือก/ยกเลิก รายการเดียว ─────────────────────────────────
  toggleSelect(id: number) {
    if (this.selectedIds.has(id)) {
      this.selectedIds.delete(id);
    } else {
      this.selectedIds.add(id);
    }
    this.isAllSelected =
      this.photoList.length > 0 &&
      this.photoList.every(item => this.selectedIds.has(item.id));
  }

  // ─── Checkbox: เลือก/ยกเลิก ทั้งหมด ─────────────────────────────────────
  toggleSelectAll() {
    if (this.isAllSelected) {
      this.selectedIds.clear();
      this.isAllSelected = false;
    } else {
      this.photoList.forEach(item => this.selectedIds.add(item.id));
      this.isAllSelected = true;
    }
  }

  // ─── ลบรายการเดียว ───────────────────────────────────────────────────────
  openDialogDelete(id: number) {
    Swal.fire({
      title: 'คุณต้องการลบข้อมูลนี้ใช่ไหม',
      text: 'กดยืนยันเพื่อลบข้อมูลนี้',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.pbSnapImageService.delete(id).subscribe(() => {
          this.spinner.hide();
          this.successDialog();
          this.getAll();
        }, error => {
          this.spinner.hide();
          console.error(error);
          this.failDialog('');
        });
      }
    });
  }

  // ─── ลบหลายรายการพร้อมกัน ────────────────────────────────────────────────
  openDialogDeleteSelected() {
    if (this.selectedIds.size === 0) { return; }

    Swal.fire({
      title: `คุณต้องการลบ ${this.selectedIds.size} รายการใช่ไหม`,
      text: 'กดยืนยันเพื่อลบข้อมูลที่เลือกทั้งหมด',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก'
    }).then(async (result) => {
      if (result.value) {
        this.spinner.show();
        try {
          // ลบทีละ 5 รายการเพื่อไม่ชน rate limit
          const ids = Array.from(this.selectedIds);
          const BATCH_SIZE = 5;
          for (let i = 0; i < ids.length; i += BATCH_SIZE) {
            const batch = ids.slice(i, i + BATCH_SIZE);
            await Promise.all(
              batch.map(id => this.pbSnapImageService.delete(id).toPromise())
            );
          }
          this.spinner.hide();
          this.selectedIds.clear();
          this.isAllSelected = false;
          this.successDialog();
          this.getAll();
        } catch (error) {
          this.spinner.hide();
          console.error(error);
          this.failDialog('เกิดข้อผิดพลาดในการลบบางรายการ');
        }
      }
    });
  }

  // ─── แชร์ QR Code รายการเดียว ────────────────────────────────────────────
  async shareQRCode(item: any) {
    const nav = navigator as any;
    if (!nav.share) {
      Swal.fire({
        type: 'warning',
        title: 'ไม่รองรับ',
        text: 'Browser ของคุณไม่รองรับการแชร์ กรุณาใช้งานบนมือถือ'
      });
      return;
    }

    if (!item.qrCodeUrl) {
      Swal.fire({
        type: 'info',
        title: 'กรุณารอสักครู่',
        text: 'QR Code ยังสร้างไม่เสร็จ กรุณาลองใหม่อีกครั้ง'
      });
      return;
    }

    try {
      this.spinner.show();
      const files: File[] = [await this.dataUrlToFile(item.qrCodeUrl, 'qrcode.png')];
      this.spinner.hide();

      if (nav.canShare && nav.canShare({ files })) {
        await nav.share({
          title: 'QR Code รูปถ่าย',
          text: 'แชร์ QR Code รูปถ่าย',
          files
        });
      } else {
        await nav.share({
          title: 'QR Code รูปถ่าย',
          text: item.url
        });
      }
    } catch (error) {
      this.spinner.hide();
      const err = error as any;
      if (err && err.name !== 'AbortError') {
        console.error(error);
        this.failDialog('เกิดข้อผิดพลาดในการแชร์');
      }
    }
  }

  // ─── แชร์รูปถ่าย รายการเดียว ────────────────────────────────────────────
  async shareImage(item: any) {
    const nav = navigator as any;
    if (!nav.share) {
      Swal.fire({
        type: 'warning',
        title: 'ไม่รองรับ',
        text: 'Browser ของคุณไม่รองรับการแชร์ กรุณาใช้งานบนมือถือ'
      });
      return;
    }

    if (!item.url) {
      Swal.fire({
        type: 'info',
        title: 'กรุณารอสักครู่',
        text: 'รูปถ่ายยังสร้างไม่เสร็จ กรุณาลองใหม่อีกครั้ง'
      });
      return;
    }

    try {
      this.spinner.show();
      const files: File[] = [await this.dataUrlToFile(item.url, 'image.png')];
      this.spinner.hide();

      if (nav.canShare && nav.canShare({ files })) {
        await nav.share({
          title: 'รูปถ่าย',
          text: 'แชร์รูปถ่าย',
          files
        });
      } else {
        await nav.share({
          title: 'รูปถ่าย',
          text: item.url
        });
      }
    } catch (error) {
      this.spinner.hide();
      const err = error as any;
      if (err && err.name !== 'AbortError') {
        console.error(error);
        this.failDialog('เกิดข้อผิดพลาดในการแชร์');
      }
    }
  }

  // ─── แชร์ QR Code หลายรายการผ่าน Web Share API ───────────────────────────
  async shareSelectedQRCodes() {
    if (this.selectedIds.size === 0) { return; }

    // ตรวจสอบว่า browser รองรับ Web Share API หรือไม่
    const nav = navigator as any;
    if (!nav.share) {
      Swal.fire({
        type: 'warning',
        title: 'ไม่รองรับ',
        text: 'Browser ของคุณไม่รองรับการแชร์ กรุณาใช้งานบนมือถือ'
      });
      return;
    }

    const selectedItems = this.photoList.filter(item => this.selectedIds.has(item.id));

    // ตรวจสอบว่า QR Code ทุกรายการสร้างเสร็จแล้ว
    const notReady = selectedItems.some(item => !item.qrCodeUrl);
    if (notReady) {
      Swal.fire({
        type: 'info',
        title: 'กรุณารอสักครู่',
        text: 'QR Code บางรายการยังสร้างไม่เสร็จ กรุณาลองใหม่อีกครั้ง'
      });
      return;
    }

    try {
      this.spinner.show();

      // แปลง QR Code (base64 dataURL) → File object ทีละรายการ
      const files: File[] = await Promise.all(
        selectedItems.map((item, index) =>
          this.dataUrlToFile(item.qrCodeUrl, `qrcode_${index + 1}.png`)
        )
      );

      this.spinner.hide();

      // ตรวจสอบว่ารองรับการแชร์ไฟล์ได้ด้วยหรือไม่
      if (nav.canShare && nav.canShare({ files })) {
        await nav.share({
          title: 'QR Code รูปถ่าย',
          text: `แชร์ QR Code จำนวน ${files.length} รายการ`,
          files
        });
      } else {
        // Fallback: แชร์เป็น URL แทน (กรณีไม่รองรับแชร์ไฟล์)
        const urls = selectedItems.map(item => item.url).join('\n');
        await nav.share({
          title: 'QR Code รูปถ่าย',
          text: `ลิงก์รูปถ่าย ${selectedItems.length} รายการ:\n${urls}`
        });
      }

    } catch (error) {
      this.spinner.hide();
      // AbortError = ผู้ใช้กดยกเลิกเอง ไม่ต้องแสดง error
      const err = error as any;
      if (err && err.name !== 'AbortError') {
        console.error(error);
        this.failDialog('เกิดข้อผิดพลาดในการแชร์');
      }
    }
  }

  // ─── แชร์รูปถ่ายหลายรายการผ่าน Web Share API ───────────────────────────
  async shareSelectedImages() {
    if (this.selectedIds.size === 0) { return; }

    // ตรวจสอบว่า browser รองรับ Web Share API หรือไม่
    const nav = navigator as any;
    if (!nav.share) {
      Swal.fire({
        type: 'warning',
        title: 'ไม่รองรับ',
        text: 'Browser ของคุณไม่รองรับการแชร์ กรุณาใช้งานบนมือถือ'
      });
      return;
    }

    const selectedItems = this.photoList.filter(item => this.selectedIds.has(item.id));

    // ตรวจสอบว่า QR Code ทุกรายการสร้างเสร็จแล้ว
    const notReady = selectedItems.some(item => !item.url);
    if (notReady) {
      Swal.fire({
        type: 'info',
        title: 'กรุณารอสักครู่',
        text: 'รูปถ่ายบางรายการยังสร้างไม่เสร็จ กรุณาลองใหม่อีกครั้ง'
      });
      return;
    }

    try {
      this.spinner.show();

      // แปลง QR Code (base64 dataURL) → File object ทีละรายการ
      const files: File[] = await Promise.all(
        selectedItems.map((item, index) =>
          this.dataUrlToFile(item.url, `image_${index + 1}.png`)
        )
      );

      this.spinner.hide();

      // ตรวจสอบว่ารองรับการแชร์ไฟล์ได้ด้วยหรือไม่
      if (nav.canShare && nav.canShare({ files })) {
        await nav.share({
          title: 'รูปถ่าย',
          text: `แชร์รูปถ่าย จำนวน ${files.length} รายการ`,
          files
        });
      } else {
        // Fallback: แชร์เป็น URL แทน (กรณีไม่รองรับแชร์ไฟล์)
        const urls = selectedItems.map(item => item.url).join('\n');
        await nav.share({
          title: 'รูปถ่าย',
          text: `ลิงก์รูปถ่าย ${selectedItems.length} รายการ:\n${urls}`
        });
      }

    } catch (error) {
      this.spinner.hide();
      // AbortError = ผู้ใช้กดยกเลิกเอง ไม่ต้องแสดง error
      const err = error as any;
      if (err && err.name !== 'AbortError') {
        console.error(error);
        this.failDialog('เกิดข้อผิดพลาดในการแชร์');
      }
    }
  }

  // ─── Helper: แปลง base64 dataURL → File ────────────────────────────────────
  private dataUrlToFile(dataUrl: string, filename: string): Promise<File> {
    return fetch(dataUrl)
      .then(res => res.blob())
      .then(blob => new File([blob], filename, { type: 'image/png' }));
  }

  // ─── Download ZIP รูปถ่าย + วิดีโอ ที่เลือก ──────────────────────────────
  async downloadZipSelected() {
    if (this.selectedIds.size === 0) { return; }

    const selectedItems = this.photoList.filter(item => this.selectedIds.has(item.id));
    const zip = new JSZip();
    this.spinner.show();

    try {
      for (let i = 0; i < selectedItems.length; i++) {
        const item = selectedItems[i];
        const num = String(i + 1).padStart(3, '0');

        // ดึงรูป
        const imgBlob = await this.pbSnapImageService.getFileAsBlob(item.url).toPromise();
        const imgExt = imgBlob.type.includes('gif') ? 'gif' : imgBlob.type.includes('png') ? 'png' : 'jpg';
        zip.file(`image_${num}.${imgExt}`, imgBlob);

        // ดึงวิดีโอ (ถ้ามี)
        if (item.videoUrl) {
          const vidBlob = await this.pbSnapImageService.getFileAsBlob(item.videoUrl).toPromise();
          const vidExt = vidBlob.type.includes('webm') ? 'webm' : 'mp4';
          zip.file(`video_${num}.${vidExt}`, vidBlob);
        }

        // delay 100ms ระหว่างแต่ละไฟล์ ป้องกัน rate limit
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      const blob = await zip.generateAsync({ type: 'blob' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `pb-snap-${Date.now()}.zip`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      this.failDialog('เกิดข้อผิดพลาดในการสร้างไฟล์ ZIP');
    } finally {
      this.spinner.hide();
    }
  }

  loadImage(item: any) {
    if (item.imageLoaded || item.imageLoading) { return; }
    item.imageLoading = true;

    const img = new Image();
    img.onload = () => {
      item.imageLoading = false;
      item.imageLoaded = true;
    };
    img.onerror = () => {
      item.imageLoading = false;
    };
    img.src = item.url + '?v=' + item.updated_at;
  }

  // ─── Dialog helpers ──────────────────────────────────────────────────────
  successDialog() {
    Swal.fire('ทำรายการสำเร็จ!', '', 'success');
  }

  failDialog(msg: string) {
    Swal.fire({
      type: 'error',
      title: 'เกิดข้อผิดพลาด',
      text: msg
    });
  }
}